import {
  MedicamentEnumDto,
  ProcedureDto,
  ProcedureSearchRequest,
  TarmedProcedureDto,
  TarmedProcedureSearchRequest,
  TarmedProcedureUpdateRequest,
  UpsertProcedureDto
} from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/procedures`;

export const getAllTariffCodesForProcedure = (source: CancelTokenSource): Promise<Array<MedicamentEnumDto>> => {
  return axios
      .get(`${apiUri}/tariff-codes`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchProcedure = (procedureSearchRequest: Partial<ProcedureSearchRequest>,
                                source: CancelTokenSource): Promise<Array<ProcedureDto>> => {
  return axios
      .post(`${apiUri}/search`, procedureSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const searchTarmedProcedure = (tarmedProcedureSearchRequest: Partial<TarmedProcedureSearchRequest>,
                                      source: CancelTokenSource): Promise<Array<TarmedProcedureDto>> => {
  return axios
      .post(`${apiUri}/tarmed/search`, tarmedProcedureSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const getAllSelectedProceduresByTariffId = (tariffId: number, source: CancelTokenSource,
                                                   orderBy?: string): Promise<Array<ProcedureDto>> => {
  if (orderBy) {
    return axios
        .get(`${apiUri}/selected/${tariffId}?orderBy=${orderBy}`, {cancelToken: source.token})
        .then((response) => response.data);
  } else {
    return axios
        .get(`${apiUri}/selected/${tariffId}`, {cancelToken: source.token})
        .then((response) => response.data);
  }
};

export const findProcedureById = (procedureId: number, source: CancelTokenSource): Promise<UpsertProcedureDto> => {
  return axios
      .get(`${apiUri}/${procedureId}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const updateProcedureSelection = (procedures: Array<number>,
                                         tariffId: number,
                                         source: CancelTokenSource): Promise<Array<ProcedureDto>> => {
  return axios
      .post(`${apiUri}/selection/${tariffId}`, procedures, {cancelToken: source.token})
      .then(response => response.data)
};

export const addProcedure = (upsertProcedureDto: Partial<UpsertProcedureDto>, source: CancelTokenSource): Promise<ProcedureDto> => {
  return axios
      .post(apiUri, upsertProcedureDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editProcedure = (procedureId: number, upsertProcedureDto: Partial<UpsertProcedureDto>,
                              source: CancelTokenSource): Promise<ProcedureDto> => {
  return axios
      .put(`${apiUri}/${procedureId}`, upsertProcedureDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const changeTarmedProcedureSelection = (procedureId: number, selection: number,
                                               source: CancelTokenSource): Promise<TarmedProcedureDto> => {
  return axios
      .put(`${apiUri}/${procedureId}/${selection}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteProcedure = (procedureId: number, source: CancelTokenSource): Promise<ProcedureDto> => {
  return axios
      .delete(`${apiUri}/${procedureId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const updateTarmedProcedures = (tarmedProcedureUpdateRequest: TarmedProcedureUpdateRequest,
                                       source: CancelTokenSource): Promise<Array<TarmedProcedureDto>> => {
  return axios
      .post(`${apiUri}/tarmed/update`, tarmedProcedureUpdateRequest, {cancelToken: source.token})
      .then(response => response.data);
};
